import React, { useState  } from 'react';
import { Menubar } from '../common/Assetsmanger';
import { Outlet, Link } from "react-router-dom";
import { Downloadicon } from "../common/Assetsmanger";
import  sivasooriyancv from "../assets/PDF/Siva sooriyan.M.pdf";
import ProgressBar from "react-scroll-progress-bar";
function Navbarcom() {
    console.log(sivasooriyancv);

    const [menustatus , Setmenustatus] = useState(false)
    function menufunc(){
        
        if(menustatus){
            Setmenustatus(false)  
        } 
        else{
            Setmenustatus(true)
        }
       
    }
    const onButtonClick = () => {
     
        // using Java Script method to get PDF file
        fetch(sivasooriyancv).then((response) => {
            response.blob().then((blob) => {
             
                // Creating new object of PDF file
                const fileURL =
                    window.URL.createObjectURL(blob);
                     console.log();
                // Setting various property values
                let alink = document.createElement("a");
                alink.href = fileURL;
                alink.download = "Sivasooriyan.M.pdf";
                alink.click();
            });
        });
    };
  return (
    <div className='nav-barsec fixed top-0 left-0 right-0 z-10'>
        
    <div className="flex flex-wrap text-white items-center  justify-around ">
    <div data-aos="fade-zoom-in" className="w-full sm:w-4/8 md:w-4/8 lg:w-6/12 xl:w-6/12 p-4  ps-4 justify-between lg:ps-28 text-center lg:text-start flex">
     <span className='text-xl'> <Link to="/">My Portfolio</Link></span>    
    <img  className='block lg:hidden' src={Menubar} width={30} alt=''  onClick={menufunc} />
    </div>
  
    <div className="w-full sm:w-1/5 md:w-1/5 lg:w-1/12 xl:w-1/12 p-4 text-start cursor-pointer  hidden lg:block lg:text-center"><Link to="/">Home</Link></div>
    <div className="w-full sm:w-1/5 md:w-1/5 lg:w-1/12 xl:w-1/12 p-4 text-start cursor-pointer hidden lg:block lg:text-center"><Link to="/AboutMe">AboutMe</Link></div>
    <div className="w-full sm:w-1/5 md:w-1/5 lg:w-1/12 xl:w-1/12 p-4 text-start cursor-pointer hidden lg:block lg:text-center"><Link to="/Skills">Skills</Link></div>    
    <div className="w-full sm:w-1/5 md:w-1/5 lg:w-1/12 xl:w-1/12 p-4 text-start  cursor-pointer hidden lg:block lg:text-center"><Link to="/ContactInfo">ContactInfo</Link></div>
    <div className="w-full sm:w-1/5 md:w-1/5 lg:w-2/12 xl:w-2/12 p-4 text-start  cursor-pointer hidden lg:flex lg:text-center justify-center items-center" onClick={onButtonClick}>Download CV <img src={Downloadicon} width={"20px"} style={{paddingLeft:'0.2rem'}}  alt='Download CV' title='Download CV'/> </div>

    {menustatus ? 
    (
        <div className='flex flex-wrap text-white mx-1 '>

        <div className="w-full sm:w-1/8 md:w-1/8 lg:w-1/12 xl:w-1/12 text-center cursor-pointer menuhide block lg:hidden lg:text-center">
            <p className='p-4 mb-0'> <Link to="/">Home</Link></p>
        </div>
        <div className="w-full sm:w-1/8 md:w-1/8 lg:w-1/12 xl:w-1/12 text-center cursor-pointer menuhide block lg:hidden lg:text-center">
            <p className='p-4 mb-0'><Link to="/AboutMe">AboutMe</Link></p>
        </div>
        <div className="w-full sm:w-1/8 md:w-1/8 lg:w-1/12 xl:w-1/12  text-center cursor-pointer menuhide block lg:hidden lg:text-center">
            <p className='p-4 mb-0'><Link to="/Skills">Skills</Link></p></div>    
        <div className="w-full sm:w-1/8 md:w-1/8 lg:w-1/12 xl:w-1/12  text-center cursor-pointer menuhide block lg:hidden lg:text-center">
            <p className='p-4 mb-0'><Link to="/ContactInfo">ContactInfo</Link></p>
        </div>
        <div className="w-full sm:w-1/8 md:w-1/8 lg:w-1/12 xl:w-1/12  text-center cursor-pointer menuhide block lg:hidden lg:text-center">
            <p className='p-4 mb-0 flex justify-center items-center'  onClick={onButtonClick}>Download CV <img src={Downloadicon} width={"20px"} style={{paddingLeft:'0.2rem'}}  alt='Download CV' title='Download CV'/></p>
        </div>
        </div>
    ):
    (
        <div></div>
    )}
  </div>
  <ProgressBar height="4px"  bgcolor="#d8ac48bf"   duration="0.2" />
 
    </div>
   
  )
}

export default Navbarcom